export default {"searchBarWrapper":"_5yyl-","searchInputBox":"_1d32G","iconSearch":"ocZpW","input":"WiwoS","searchButtonBar":"_8g3Gd","close":"qO048"};